function extractGitLabInfo(url) {
  const regex = /https:\/\/([^\/]+)\/(.+?)\/([^\/]+)\/-\/blob\/([^\/]+)\/(.*)$/;
  const match = url.match(regex);
  if (!match) {
    throw new Error("Invalid URL ;@");
  }
  const [_, host, group, repo, branch, filePath] = match;
  return {
    host,
    group,
    repo,
    branch,
    filePath: filePath || ""
  };
}

export { extractGitLabInfo };
//# sourceMappingURL=extractGitlabInfo.esm.js.map
